import { handleSpaceAndEnter } from '@app/utils/handleEnterKey';
import { useTranslation } from 'react-i18next';

import { CancelSmall } from '../Icons';

interface Props {
  onClick?: () => void;
}

export const ClearButton = ({ onClick }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={t('common:clear')}
      className="flex rounded-small focus-visible:focus-outline"
      onKeyDown={handleSpaceAndEnter(onClick)}
      onClick={onClick}
    >
      <CancelSmall className="size-4 text-neutral-40" />
    </div>
  );
};
